import { useEntityTitleDuplicateValidation } from './useEntityTitleDuplicateValidation'

type UseFormTitleDuplicateValidationProps = {
  defaultValue?: string
}

export const useFormTitleDuplicateValidation = ({
  defaultValue = '',
}: UseFormTitleDuplicateValidationProps = {}) =>
  useEntityTitleDuplicateValidation({ entityType: 'form', defaultValue })
